module.exports = __webpack_public_path__ + "img/wheretobuy-img.dfae7826.jpeg";